/**
 * Build Your Mini Charm Bracelet (snippets/mini-charm-builder.liquid): bracelet, necklace or ring + soldered mini charms.
 *
 * Quick-start sets -> 1. choose your piece (+ metal, ring size) -> 2. add your charms -> 3. review -> cart, with a live
 * preview that redraws what the set images' scene (wf_product_photos/mini-charm-preview/mc_scene.py) draws: each charm
 * at its true size in mm, on a jump ring, hanging from the chain at the spec's spacing (bracelet: laid flat, charms
 * pointing outward; necklace: hanging straight down) or across the ring's loop, fanned so bodies never overlap.
 *
 * Rules (owner + base specs, 2026-10-14): bracelet/necklace take exactly 3, 5 or 7 charms, the ring 1-3; every charm is
 * SOLDERED on in the chosen order (no extras, nothing ships loose); one metal per piece; the photo gem, portrait and
 * locket only in the CENTER spot of a chain, the mini photo charm only on the ring.
 *
 * Cart model = the floating locket's and the charm-set quick-start bundles': one base line (_charm_bundle_parent,
 * visible "Charm N" titles in position order for the packer) + one line per charm (_charm_bundle_child, _slot_position).
 * ajax-cart.js shows them as one row, and removing the base removes its charms.
 *
 * Builder-agnostic parts come from assets/wf-builder-kit.js (shared with the floating locket builder); the markup uses
 * the shared fl- classes / data-fl- hooks plus mc- for what only this builder has (metal, order).
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-mc-root]');
  var K = window.WFBuilderKit;
  if (!root || root.__mc || !K) return;
  root.__mc = true;

  var DATA, PV;
  try {
    DATA = JSON.parse(root.querySelector('[data-mc-data]').textContent);
    PV = JSON.parse(root.querySelector('[data-mc-preview]').textContent);
  } catch (e) {
    console.error('[MiniCharm] bad data', e);
    return;
  }
  var CFG = DATA.config;
  var REDUCED = K.REDUCED;
  var STORE_KEY = 'wf_mini_charm_v1';
  var esc = K.esc, money = K.money, uid = K.uid, plural = K.plural;
  var variantValue = K.variantValue, variantLabel = K.variantLabel, isStone = K.isStone;
  var MONTHS = K.MONTHS, BS_MONTH = K.BS_MONTH;

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function shortName(title) { return String(title || '').replace(/^\s*Mini\s+/i, '').replace(/\s+Charm\s*$/i, '').trim(); }

  var dialogs = {
    set: $('[data-fl-dialog="set"]'), picker: $('[data-fl-dialog="picker"]'),
    photo: $('[data-fl-dialog="photo"]'), zoom: $('[data-fl-dialog="zoom"]')
  };
  var UI = K.ui(root, { dialogs: dialogs });
  var announce = UI.announce, openDialog = UI.openDialog, closeDialog = UI.closeDialog;

  /* -------------------------------------------------------------------------------------------- catalog */
  var METALS = ['Gold', 'Silver'];
  function optIndex(p, re) { for (var i = 0; i < p.options.length; i++) if (re.test(p.options[i])) return i; return -1; }
  function metalOf(v) { var i = optIndex(v.product, /^metal$/i); return i > -1 ? v.options[i] : 'Gold'; }
  function mkey(metal) { return String(metal).toLowerCase() === 'silver' ? 'silver' : 'gold'; }

  var PHOTO_CFG = {};
  (CFG.photoCharms || []).forEach(function (c) { PHOTO_CFG[c.handle] = c; });
  var SKU = {};
  function prep(p) {
    K.prepProduct(p, shortName);
    p.metalIdx = optIndex(p, /^metal$/i);
    p.photoCfg = PHOTO_CFG[p.handle] || null;
    p.isPhoto = !!p.photoCfg;
    if (p.photoCfg && p.photoCfg.short) p.short = p.photoCfg.short;
    p.variants.forEach(function (v) { if (v.sku) SKU[v.sku] = v; });
    return p;
  }
  var CHARMS = (DATA.charms || []).concat(DATA.photoCharms || [])
    .filter(function (p) { return p && p.variants && p.variants.length; }).map(prep);
  var ORDER = CFG.order || [];
  function orderIndex(p) {
    for (var i = 0; i < ORDER.length; i++) if (p.handle.indexOf(ORDER[i]) > -1) return i;
    return ORDER.length;
  }
  CHARMS.sort(function (a, b) { return orderIndex(a) - orderIndex(b); });
  function byHandle(h) { for (var i = 0; i < CHARMS.length; i++) if (CHARMS[i].handle === h) return CHARMS[i]; return null; }

  var BASES = [];
  (CFG.bases || []).forEach(function (b, i) {
    var p = (DATA.bases || [])[i];
    if (p && p.variants && p.variants.length && PV.bases[b.key]) {
      p.variants.forEach(function (v) { v.product = p; });
      BASES.push({ key: b.key, label: b.label, noun: b.noun || b.label.toLowerCase(), blurb: b.blurb, counts: b.counts,
                   spacing: b.spacing || {}, max: Math.max.apply(null, b.counts), product: p, geo: PV.bases[b.key],
                   sizeIdx: optIndex(p, /^size$/i) });
    }
  });
  if (!BASES.length || !CHARMS.length) {
    console.warn('[MiniCharm] no bases or charms published');
    root.classList.add('fl--empty');
    root.insertAdjacentHTML('afterbegin', '<p class="fl-lede">Our mini charm jewelry is coming soon. Check back shortly to design yours.</p>');
    return;
  }
  function baseByKey(k) { for (var i = 0; i < BASES.length; i++) if (BASES[i].key === k) return BASES[i]; return null; }
  function isChain(b) { return b && b.key !== 'ring'; }

  /** the variant of a charm in a metal, with the same pick value (initial, number, birth month) */
  function variantFor(p, metal, value) {
    var pi = p.pickOption ? p.options.indexOf(p.pickOption) : -1;
    var vs = p.variants.filter(function (v) { return p.metalIdx < 0 || v.options[p.metalIdx] === metal; });
    if (pi > -1 && value != null) vs = vs.filter(function (v) { return v.options[pi] === value; });
    return vs[0] || null;
  }
  /** a charm's variants in one metal, in reading order (A-Z, 0-9, January-December) */
  function variantsIn(p, metal) {
    var vs = p.variants.filter(function (v) { return p.metalIdx < 0 || v.options[p.metalIdx] === metal; });
    if (!p.multi) return vs;
    return vs.slice().sort(function (a, b) {
      var x = variantValue(a), y = variantValue(b);
      if (isStone(p)) return (BS_MONTH[x] == null ? 99 : BS_MONTH[x]) - (BS_MONTH[y] == null ? 99 : BS_MONTH[y]);
      if (/^\d+$/.test(x) && /^\d+$/.test(y)) return Number(x) - Number(y);
      return x < y ? -1 : x > y ? 1 : 0;
    });
  }
  function anyAvailable(p, metal) { return variantsIn(p, metal).some(function (v) { return v.available; }); }
  function allowedOn(p, b) { return !p.photoCfg || p.photoCfg.bases.indexOf(b.key) > -1; }

  /* ---------------------------------------------------------------------------------------------- state */
  // items, LEFT TO RIGHT as soldered: {uid, product, value (pick option value | null), photo, name}
  var state = { baseKey: null, metal: 'Gold', size: null, items: [], cat: 'all' };
  function currentBase() { return baseByKey(state.baseKey); }
  function newItem(p, value, photo, name) { return { uid: uid(), product: p, value: value == null ? null : value, photo: photo || null, name: name || '' }; }
  function itemVariant(it, metal) { return variantFor(it.product, metal || state.metal, it.value); }
  function sizesOf(b) {
    if (!b || b.sizeIdx < 0) return [];
    var out = [];
    b.product.variants.forEach(function (v) { var s = v.options[b.sizeIdx]; if (out.indexOf(s) < 0) out.push(s); });
    return out;
  }
  function baseVariant(b, metal, size) {
    if (!b) return null;
    var mi = optIndex(b.product, /^metal$/i);
    var vs = b.product.variants.filter(function (v) { return mi < 0 || v.options[mi] === metal; });
    if (b.sizeIdx > -1) vs = vs.filter(function (v) { return v.options[b.sizeIdx] === size; });
    return vs[0] || null;
  }
  function inStock(b, metal) {
    var mi = optIndex(b.product, /^metal$/i);
    return b.product.variants.some(function (v) { return v.available && (!metal || mi < 0 || v.options[mi] === metal); });
  }
  function metalInStock(b, metal) { return inStock(b, metal); }

  /**
   * A photo charm that can't go on this base takes the place of one that can, keeping the photo: the photo gem,
   * portrait and locket are chain-only, so on the ring they become the round photo charm (owner 10/15: photo charms
   * go in any spot, as many as fit; the round photo charm goes on every base).
   */
  function convertFor(p, b) {
    if (allowedOn(p, b) || !p.isPhoto) return p;
    var q = byHandle(CFG.ringPhoto);
    return q && allowedOn(q, b) ? q : p;
  }
  function countRule(b) {
    if (!b) return '';
    if (isChain(b)) return 'Choose 3, 5 or 7 charms. Each one is soldered onto the chain in the order you choose.';
    return 'Choose 1, 2 or 3 charms. They are soldered onto the ring’s little loop in the order you choose.';
  }
  /** what's missing for a valid count, or '' ("Add 2 more charms", "Add 1 more or remove 1") */
  function countNeed(b, n) {
    if (!b || b.counts.indexOf(n) > -1) return '';
    if (n > b.max) return 'Remove ' + plural(n - b.max, 'charm', 'charms') + ' (the ' + b.noun + ' holds ' + b.max + ')';
    var up = b.counts.filter(function (c) { return c > n; })[0];
    var down = b.counts.filter(function (c) { return c < n; }).pop();
    if (!n) return isChain(b) ? 'Add 3, 5 or 7 charms' : 'Add up to 3 charms';
    if (down != null && up - n === 1 && n - down === 1) return 'Add 1 more charm or remove 1';
    return 'Add ' + plural(up - n, 'more charm', 'more charms');
  }

  function save() {
    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify({
        baseKey: state.baseKey, metal: state.metal, size: state.size,
        items: state.items.map(function (it) { return { h: it.product.handle, v: it.value, photo: it.photo ? { url: it.photo.url } : null, name: it.name || '' }; })
      }));
    } catch (e) { /* private mode */ }
  }
  function restore() {
    try {
      var s = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
      if (!s) return false;
      var sb = s.baseKey && baseByKey(s.baseKey);
      if (sb && inStock(sb)) state.baseKey = s.baseKey;
      if (METALS.indexOf(s.metal) > -1) state.metal = s.metal;
      state.size = s.size || null;
      (s.items || []).forEach(function (r) {
        var p = byHandle(r.h);
        if (p) state.items.push(newItem(p, r.v, r.photo && r.photo.url ? K.photoFromUrl(r.photo.url) : null, r.name));
      });
      return true;
    } catch (e) { return false; }
  }

  /* ------------------------------------------------------------------------------------- preview engine */
  var loadImg = K.loadImg, makeCanvas = K.makeCanvas, fitCanvas = K.fitCanvas;
  var CELL = PV.cell_mm;
  function charmInfo(v) { return v && PV.charms[v.sku]; }

  function pathAt(path, s) {
    var f = (s - path.s0) / path.ds, n = path.x.length;
    var i = Math.max(0, Math.min(n - 2, Math.floor(f))), t = Math.max(0, Math.min(1, f - i));
    var x = path.x[i] + (path.x[i + 1] - path.x[i]) * t, y = path.y[i] + (path.y[i + 1] - path.y[i]) * t;
    function pt(u) {
      var g = (u - path.s0) / path.ds, j = Math.max(0, Math.min(n - 2, Math.floor(g))), w = Math.max(0, Math.min(1, g - j));
      return [path.x[j] + (path.x[j + 1] - path.x[j]) * w, path.y[j] + (path.y[j + 1] - path.y[j]) * w];
    }
    var a = pt(s - 0.5), c = pt(s + 0.5), tx = c[0] - a[0], ty = c[1] - a[1], L = Math.hypot(tx, ty) || 1;
    return { x: x, y: y, tx: tx / L, ty: ty / L };
  }
  /** mm between neighbours for n charms: the spec's for 3/5/7; a count in between uses the next one up's */
  function spacingFor(b, n) {
    var sp = b.spacing || {};
    if (sp[n] != null) return sp[n];
    var up = b.counts.filter(function (c) { return c >= n; })[0];
    return sp[up != null ? up : b.max] || 24;
  }
  function slotPositions(b, n) {
    var sp = spacingFor(b, n), out = [];
    for (var k = 0; k < n; k++) out.push((k - (n - 1) / 2) * sp);
    return out;
  }
  function hangAngle(hx, hy) { return Math.atan2(-hx, hy); }   // radians, clockwise: turns (0, 1) into (hx, hy)
  function barTop(x, L) { var u = Math.max(-1, Math.min(1, (x - L.cx) / L.a)); return L.cy + L.b * Math.sqrt(1 - u * u) - L.r; }

  var MASKS = {};
  function decodeMask(sku) {
    if (MASKS[sku]) return MASKS[sku];
    var info = PV.charms[sku];
    if (!info) return null;
    var cols = info.mask[0], rows = info.mask[1], bin = atob(info.mask[2]);
    var cells = [];
    for (var i = 0; i < cols * rows; i++) if ((bin.charCodeAt(i >> 3) >> (7 - (i & 7))) & 1) cells.push(i % cols, Math.floor(i / cols));
    MASKS[sku] = { cols: cols, rows: rows, cells: cells };
    return MASKS[sku];
  }
  var FANS = {};
  /**
   * The ring's charms start at their jump rings' lean, then the outer ones swing outward (3-degree steps, the middle one
   * stays) until neighbouring BODIES overlap by at most fan.tol of the smaller one; cells within fan.loop_mm of either
   * pivot don't count (the loops stack in depth). Same algorithm and masks as mc_scene.ring_fan, so the set images match.
   */
  function ringFan(skus, piv, init) {
    var n = skus.length, key = skus.join(',');
    if (n < 2) return init.slice();
    if (FANS[key]) return FANS[key];
    var F = PV.fan, angs = init.slice();
    function cells(i, deg) {
      var M = decodeMask(skus[i]), info = PV.charms[skus[i]];
      var t = deg * Math.PI / 180, c = Math.cos(t), s = Math.sin(t), out = {}, cnt = 0;
      for (var k = 0; k < M.cells.length; k += 2) {
        var px = (M.cells[k] + 0.5) * CELL - info.anchor[0], py = (M.cells[k + 1] + 0.5) * CELL - info.anchor[1];
        var X = piv[i][0] + px * c - py * s, Y = piv[i][1] + px * s + py * c;
        var id = Math.floor(X / CELL) + ',' + Math.floor(Y / CELL);
        if (!out[id]) { out[id] = 1; cnt++; }
      }
      return { set: out, n: cnt };
    }
    function near(id, i) {
      var p = id.split(','), x = (Number(p[0]) + 0.5) * CELL, y = (Number(p[1]) + 0.5) * CELL;
      return Math.hypot(x - piv[i][0], y - piv[i][1]) < F.loop_mm;
    }
    for (var step = 0; step < Math.floor(F.max / F.step); step++) {
      var cs = angs.map(function (a, i) { return cells(i, a); }), hit = false;
      for (var i = 0; i < n - 1; i++) {
        var both = 0;
        for (var id in cs[i].set) if (cs[i + 1].set[id] && !near(id, i) && !near(id, i + 1)) both++;
        if (both > F.tol * Math.min(cs[i].n, cs[i + 1].n)) hit = true;
      }
      if (!hit) break;
      angs[0] += F.step; angs[n - 1] -= F.step;
    }
    FANS[key] = angs;
    return angs;
  }

  var SWINGS = {};
  /**
   * How far (deg, clockwise) a necklace charm swings outward about its chain point P so its body clears the chain: on
   * the product photos the charms on the sloping arms rest against the chain's OUTER side, just outside the V. side = +1
   * on the left arm, -1 on the right. Mask cells within swing.near mm of P (loop + jump ring) don't count; the chain is
   * its centre line (1 mm segments within 20 mm) +- swing.clear. Same test as mc_scene.neck_swing.
   */
  function neckSwing(P, s0, side, sku, path, dd) {
    var key = sku + '@' + s0;
    if (SWINGS[key] != null) return SWINGS[key];
    var W = PV.swing, M = decodeMask(sku), info = PV.charms[sku], seg = [];
    for (var j = 0; j < path.x.length; j++) if (Math.abs(path.s0 + j * path.ds - s0) < 20) seg.push(path.x[j], path.y[j]);
    var ncell = M.cells.length / 2, a = 0;
    for (var k = 0; ; k++) {
      a = side * k * W.step;
      var t = a * Math.PI / 180, c = Math.cos(t), sn = Math.sin(t), qx = P[0] - dd * sn, qy = P[1] + dd * c, bad = 0;
      for (var m = 0; m < M.cells.length; m += 2) {
        var px = (M.cells[m] + 0.5) * CELL - info.anchor[0], py = (M.cells[m + 1] + 0.5) * CELL - info.anchor[1];
        var X = qx + px * c - py * sn, Y = qy + px * sn + py * c;
        if (Math.hypot(X - P[0], Y - P[1]) <= W.near) continue;
        var dmin = Infinity;
        for (var g = 0; g + 3 < seg.length; g += 2) {
          var ax = seg[g], ay = seg[g + 1], dx = seg[g + 2] - ax, dy = seg[g + 3] - ay;
          var u = Math.max(0, Math.min(1, ((X - ax) * dx + (Y - ay) * dy) / (dx * dx + dy * dy)));
          dmin = Math.min(dmin, Math.hypot(X - ax - u * dx, Y - ay - u * dy));
        }
        if (dmin < W.clear) bad++;
      }
      if (bad <= W.tol * ncell || k * W.step >= W.max) break;
    }
    SWINGS[key] = a;
    return a;
  }
  function down(d, deg) { var t = deg * Math.PI / 180; return [-d * Math.sin(t), d * Math.cos(t)]; }

  /**
   * Where every charm goes: [{it, v, info, jr: {key, top: [x, y] mm, deg}, q: [x, y] mm, rot (rad)}] in display order
   * (left to right). As on the product photos: on the chains each charm hangs on an edge-on jump ring whose top wraps the
   * link; on the ring the jump rings stand on the loop as RING_LAYOUT places them. Mirrors mc_scene.placements.
   */
  function placements(b, items, metal) {
    var geo = b.geo, J = PV.jr, out = [];
    var drawn = items.slice(0, b.max).map(function (it) { return { it: it, v: itemVariant(it, metal) }; })
      .filter(function (o) { return o.v && charmInfo(o.v); });
    var n = drawn.length;
    if (!n) return out;
    var hang = J.h - J.wire;                         // jump ring top -> its bottom wire's top, where a charm's hole rests
    if (geo.hang === 'ring') {
      var L = geo.loop, lay = (J.ring.layout[n] || J.ring.layout['3']).slice(0, n);
      var rings = lay.map(function (r) {
        var top = [r[1], barTop(r[1], L) - J.ring.top_above], d = down(hang, r[2]);
        return { key: 'ring-' + r[0], top: top, deg: r[2], piv: [top[0] + d[0], top[1] + d[1]] };
      });
      var angs = ringFan(drawn.map(function (o) { return o.v.sku; }), rings.map(function (r) { return r.piv; }),
                         rings.map(function (r) { return r.deg; }));
      drawn.forEach(function (o, i) {
        var r = rings[i];
        out.push({ it: o.it, v: o.v, info: charmInfo(o.v), jr: { key: r.key, top: r.top, deg: r.deg, flip: lay[i][1] > 0 },
                   q: r.piv, rot: angs[i] * Math.PI / 180 });
      });
      return out;
    }
    var pos = slotPositions(b, n), dd = J.chain.top + hang;
    drawn.forEach(function (o, i) {
      var P = pathAt(geo.path, pos[i]);
      var hx = geo.hang === 'radial' ? -P.ty : 0, hy = geo.hang === 'radial' ? P.tx : 1;
      var deg = hangAngle(hx, hy) * 180 / Math.PI;
      if (geo.hang === 'down' && Math.abs(pos[i]) > 1e-6 && PV.swing)     // rests against the chain's outer side
        deg += neckSwing([P.x, P.y], pos[i], pos[i] < 0 ? 1 : -1, o.v.sku, geo.path, dd);
      var t = deg * Math.PI / 180, ux = -Math.sin(t), uy = Math.cos(t);
      out.push({
        it: o.it, v: o.v, info: charmInfo(o.v),
        jr: { key: 'chain', top: [P.x + ux * J.chain.top, P.y + uy * J.chain.top], deg: deg, flip: false },
        q: [P.x + ux * dd, P.y + uy * dd], rot: t
      });
    });
    return out;
  }

  function placeholderPhoto(ctx, x, y, w, h, round) {
    var cx = x + w / 2, cy = y + h / 2, r = Math.min(w, h) / 2;
    var g = ctx.createRadialGradient(cx - r * 0.3, cy - r * 0.35, r * 0.1, cx, cy, Math.max(w, h) / 2);
    g.addColorStop(0, '#f3efe9'); g.addColorStop(1, '#d9d1c5');
    ctx.fillStyle = g;
    ctx.fillRect(x, y, w, h);
    ctx.fillStyle = 'rgba(255,255,255,0.85)';
    ctx.beginPath(); ctx.arc(cx, cy - r * 0.18, r * 0.3, 0, Math.PI * 2); ctx.fill();
    ctx.beginPath(); ctx.ellipse(cx, cy + r * 0.62, r * 0.55, r * 0.42, 0, Math.PI, 0); ctx.fill();
  }
  function windowPath(ctx, win, k) {
    ctx.beginPath();
    if (win.shape === 'circle') { ctx.arc(win.cx * k, win.cy * k, win.r * k, 0, Math.PI * 2); return; }
    var x = win.x * k, y = win.y * k, w = win.w * k, h = win.h * k, r = Math.min(win.rad * k, w / 2, h / 2);
    ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath();
  }
  /** One charm (photo or placeholder under its window, the portrait's name) on its own canvas at k px/mm. */
  function charmLayer(info, img, photoImg, name, k) {
    var w = Math.max(1, Math.ceil(info.w_mm * k)), h = Math.max(1, Math.ceil(info.h_mm * k));
    var c = makeCanvas(w, h), x = c.getContext('2d');
    var win = info.photo;
    if (win && win.shape !== 'gem') {                // printed photo windows; the photo gem's face stays dark
      x.save(); windowPath(x, win, k); x.clip();
      var bx = win.shape === 'circle' ? (win.cx - win.r) * k : win.x * k, by = win.shape === 'circle' ? (win.cy - win.r) * k : win.y * k;
      var bw = win.shape === 'circle' ? 2 * win.r * k : win.w * k, bh = win.shape === 'circle' ? 2 * win.r * k : win.h * k;
      if (photoImg) {
        var s = Math.max(bw / photoImg.naturalWidth, bh / photoImg.naturalHeight);
        var iw = photoImg.naturalWidth * s, ih = photoImg.naturalHeight * s;
        x.drawImage(photoImg, bx + (bw - iw) / 2, by + (bh - ih) / 2, iw, ih);
      } else {
        placeholderPhoto(x, bx, by, bw, bh, win.shape === 'circle');
      }
      if (name && win.name_h) {                      // the portrait's printed name, white on a dark band
        var nh = win.name_h * k;
        var g = x.createLinearGradient(0, by, 0, by + nh * 1.25);
        g.addColorStop(0, 'rgba(0,0,0,0.78)'); g.addColorStop(1, 'rgba(0,0,0,0)');
        x.fillStyle = g; x.fillRect(bx, by, bw, nh * 1.25);
        x.fillStyle = '#fff';
        x.font = '600 ' + Math.max(4, nh * 0.62) + 'px "ITC Avant Garde Gothic", "Futura Medium", Arial, sans-serif';
        x.textAlign = 'center'; x.textBaseline = 'middle';
        x.fillText(String(name).toUpperCase(), bx + bw / 2, by + nh * 0.55, bw * 0.9);
      }
      x.restore();
    }
    x.drawImage(img, 0, 0, w, h);
    return c;
  }

  /**
   * The photo gem's bubble, as on its product photo (bubble_over.py): the gem's face stays dark and the photo shows in a
   * circle beside it, joined by a grey wedge from the gem's centre to the circle's tangent points that lies OVER the
   * metal and stops at the dark dome. The shopper's photo (cover-cropped), or the placeholder until one is uploaded.
   */
  function drawBubble(ctx, D, k, px, g, B, metal) {
    // a gem right of the middle points its bubble left, into the piece (photo charms go in any spot since 10/15);
    // a centre or left gem points right, as on the gem's own photo. Same rule as mc_scene.bubble_dx.
    var sx = g.x > 3 ? -1 : 1;
    var G = px([g.x, g.y]), C = px([g.x + sx * B.dx, g.y + B.dy]), R = B.r * k;
    var dx = C[0] - G[0], dy = C[1] - G[1], d = Math.hypot(dx, dy);
    if (d > R) {
      var a = Math.atan2(dy, dx), h = Math.asin(R / d), tl = Math.sqrt(d * d - R * R);
      var L = makeCanvas(D, D), x = L.getContext('2d');
      x.fillStyle = 'rgb(' + (PV.beam_rgb || [173, 173, 173]).join(',') + ')';
      x.beginPath(); x.moveTo(G[0], G[1]);
      x.lineTo(G[0] + tl * Math.cos(a - h), G[1] + tl * Math.sin(a - h));
      x.lineTo(G[0] + tl * Math.cos(a + h), G[1] + tl * Math.sin(a + h));
      x.closePath(); x.fill();
      x.globalCompositeOperation = 'destination-out';
      x.beginPath(); x.arc(G[0], G[1], g.r * k, 0, Math.PI * 2); x.fill();
      // see-through over the charms (owner 10/15: it shouldn't block the gold), solid over the background:
      // the beam's alpha x (1 - charm alpha x (1 - beam_opacity)), like mc_scene.bubble
      var op = PV.beam_opacity != null ? PV.beam_opacity : 1;
      if (metal && op < 1) { x.globalAlpha = 1 - op; x.drawImage(metal, 0, 0); x.globalAlpha = 1; }
      ctx.drawImage(L, 0, 0);
    }
    ctx.save();
    ctx.beginPath(); ctx.arc(C[0], C[1], R, 0, Math.PI * 2); ctx.clip();
    if (g.photo) {
      var s = Math.max(2 * R / g.photo.naturalWidth, 2 * R / g.photo.naturalHeight);
      var iw = g.photo.naturalWidth * s, ih = g.photo.naturalHeight * s;
      ctx.drawImage(g.photo, C[0] - iw / 2, C[1] - ih / 2, iw, ih);
    } else {
      placeholderPhoto(ctx, C[0] - R, C[1] - R, 2 * R, 2 * R, true);
    }
    ctx.restore();
  }

  /**
   * The square (mm) a design is drawn in: the base's frame, grown just enough (and kept square, centred on everything)
   * when a charm reaches past it, e.g. a locket (21 mm) or portrait (17 mm) on the ring since photo charms go on every
   * base (owner 10/15). Normal designs keep the base's frame and zoom.
   */
  function fitFrame(b, pls) {
    var fr = b.geo.frame, m = 1.5, c = charmBox(b, pls);
    if (!c) return fr;
    var x0 = Math.min(fr[0], c[0] - m), y0 = Math.min(fr[1], c[1] - m);
    var x1 = Math.max(fr[0] + fr[2], c[2] + m), y1 = Math.max(fr[1] + fr[2], c[3] + m);
    if (x0 >= fr[0] && y0 >= fr[1] && x1 <= fr[0] + fr[2] && y1 <= fr[1] + fr[2]) return fr;
    var side = Math.max(x1 - x0, y1 - y0);
    return [(x0 + x1) / 2 - side / 2, (y0 + y1) / 2 - side / 2, side];
  }
  /** the charms' box (mm): every charm's rotated rectangle, plus a photo gem's bubble where the base draws one */
  function charmBox(b, pls) {
    if (!pls.length) return null;
    var x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity, B = b.geo.bubble;
    function add(X, Y) { x0 = Math.min(x0, X); x1 = Math.max(x1, X); y0 = Math.min(y0, Y); y1 = Math.max(y1, Y); }
    pls.forEach(function (pl) {
      var w = pl.info.w_mm, h = pl.info.h_mm, ax = pl.info.anchor[0], ay = pl.info.anchor[1], c = Math.cos(pl.rot), s = Math.sin(pl.rot);
      [[0, 0], [w, 0], [0, h], [w, h]].forEach(function (p) {
        var dx = p[0] - ax, dy = p[1] - ay;
        add(pl.q[0] + dx * c - dy * s, pl.q[1] + dx * s + dy * c);
      });
      var win = pl.info.photo;
      if (B && win && win.shape === 'gem') {        // drawBubble's circle
        var ux = win.cx - ax, uy = win.cy - ay, gx = pl.q[0] + ux * c - uy * s, gy = pl.q[1] + ux * s + uy * c;
        var bx = gx + (gx > 3 ? -1 : 1) * B.dx, by = gy + B.dy;
        add(bx - B.r, by - B.r); add(bx + B.r, by + B.r);
      }
    });
    return [x0, y0, x1, y1];
  }
  /**
   * The set dialog's framing, the same as the set cards (build_sets.square_crop): a square around what matters with a
   * 7% margin: the bracelet or ring's whole outline with its charms; on the necklace the charms plus 10 mm of chain
   * above them (the chain runs out of frame). Owner 10/15: the bracelet and necklace looked zoomed out in the quick pick.
   */
  function cardFrame(b, pls) {
    var c = charmBox(b, pls), o = b.geo.outline;
    if (!c) return b.geo.frame;
    if (b.geo.hang === 'down') c[1] -= 10;
    else if (o) c = [Math.min(c[0], o[0]), Math.min(c[1], o[1]), Math.max(c[2], o[2]), Math.max(c[3], o[3])];
    var side = Math.max(c[2] - c[0], c[3] - c[1]) * 1.14;
    return [(c[0] + c[2]) / 2 - side / 2, (c[1] + c[3]) / 2 - side / 2, side];
  }

  /**
   * [base image, {jump ring key: {all, near}}] for the jump rings these placements use (no placements: all of the
   * base's). all = the whole ring, near = only its half toward the viewer (its left arc; flipped for the right side).
   */
  function baseImages(b, metal, pls, hd) {
    var m = mkey(metal), keys = [];
    if (!pls) keys = b.geo.hang === 'ring' ? ['ring-c', 'ring-s', 'ring-d'] : ['chain'];
    else pls.forEach(function (pl) { if (keys.indexOf(pl.jr.key) < 0) keys.push(pl.jr.key); });
    var jobs = [];
    keys.forEach(function (k) { jobs.push(loadImg(PV.jr.img[k][m]), loadImg(PV.jr.near[k][m])); });
    return Promise.all([loadImg(hd && b.geo.imgHd ? b.geo.imgHd[m] : b.geo.img[m]), Promise.all(jobs)]).then(function (r) {
      var jr = {};
      keys.forEach(function (k, i) { jr[k] = { all: r[1][2 * i], near: r[1][2 * i + 1] }; });
      return [r[0], jr];
    });
  }
  var LAYERS = {};
  /** a cleared scratch canvas D px square; slot = which one ('back', 'front', 'both') */
  function layerCanvas(D, slot) {
    var id = slot + D, c = LAYERS[id] || (LAYERS[id] = makeCanvas(D, D));
    c.getContext('2d').clearRect(0, 0, D, D);
    return c;
  }
  /** the ring's loop wire outline (mm), a hair inside its edge: mc_scene.wire_tube */
  function wireTube(L) {
    var W = PV.jr.tube, d = L.r - W.inset, n = 120, inner = [], outer = [];
    for (var i = 0; i < n; i++) {
      var t = W.t0 + (Math.PI - 2 * W.t0) * i / (n - 1);
      var x = L.cx + L.a * Math.cos(t), y = L.cy + L.b * Math.sin(t);
      var nx = Math.cos(t) / L.a, ny = Math.sin(t) / L.b, nn = Math.hypot(nx, ny);
      nx /= nn; ny /= nn;
      inner.push([x - nx * d, y - ny * d]); outer.push([x + nx * d, y + ny * d]);
    }
    return inner.concat(outer.reverse());
  }
  /** one jump ring sprite, rotated deg about its top centre at top (px), mirrored when flip */
  function drawRing(x, img, top, deg, flip, k, alpha) {
    var w = img.naturalWidth / PV.px_per_mm * k, h = img.naturalHeight / PV.px_per_mm * k;
    x.save();
    x.globalAlpha = alpha;
    x.translate(top[0], top[1]);
    x.rotate(deg * Math.PI / 180);
    if (flip) x.scale(-1, 1);
    x.drawImage(img, -w / 2, 0, w, h);
    x.restore();
  }
  function photoImgFor(it) {
    if (!it.photo) return Promise.resolve(null);
    return loadImg(it.photo.local || it.photo.thumb || it.photo.url).catch(function () { return null; });
  }

  /**
   * Render into canvases. job = {base, metal, items, key, animateUid}. A newer render with the same key supersedes an
   * older one (its images may resolve later; it then draws nothing).
   */
  var SEQ = {};
  function render(canvases, job) {
    var key = job.key || 'main';
    var seq = SEQ[key] = (SEQ[key] || 0) + 1;
    canvases = canvases.filter(function (c) { return c && c.offsetParent !== null; });
    var b = job.base;
    if (!b || !canvases.length) return Promise.resolve();
    var pls = placements(b, job.items, job.metal);
    var fr = job.fit === 'card' ? cardFrame(b, pls) : fitFrame(b, pls), bf = b.geo.frame;
    // the extra-sharp base image only when the canvas would stretch the normal one (pinch zoom, a zoomed set dialog)
    var maxD = Math.max.apply(null, canvases.map(function (c) { return c.width; }));
    var hd = !!b.geo.imgHd && maxD * bf[2] / fr[2] > (b.geo.px || 1800) * 1.15;
    return Promise.all([
      baseImages(b, job.metal, pls, hd),
      Promise.all(pls.map(function (pl) { return loadImg(pl.info.img).catch(function () { return null; }); })),
      Promise.all(pls.map(function (pl) { return photoImgFor(pl.it); }))
    ]).then(function (r) {
      if (seq !== SEQ[key]) return;
      var baseImg = r[0][0], jrImgs = r[0][1], imgs = r[1], photos = r[2];
      var order = pls.map(function (_, i) { return i; });
      if (b.geo.hang === 'ring' && pls.length === 3) order = [0, 2, 1];   // the middle charm in front, as on the photo
      function drawAll(ctx, D, skip, anim) {
        K.smooth(ctx);                           // a resized canvas resets to "low" smoothing; set it on every draw
        var k = D / fr[2];
        function px(p) { return [(p[0] - fr[0]) * k, (p[1] - fr[1]) * k]; }
        // the base image covers the base's own frame; a design that needs more room draws it smaller (fitFrame)
        function drawBase(c) { c.drawImage(baseImg, (bf[0] - fr[0]) * k, (bf[1] - fr[1]) * k, bf[2] * k, bf[2] * k); }
        ctx.clearRect(0, 0, D, D);
        ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, D, D);
        drawBase(ctx);
        // Threading, as on the product photos (mc_scene.compose): the whole jump rings go on a back layer; on the ring
        // the loop wire is drawn again over them (their far halves pass behind it); the charms then hang over the
        // rings (a charm's loop covers its ring's far half) and each ring's near half goes again in front. ONE shadow
        // under both layers.
        var sh = PV.shadow, gems = [];
        var bc = layerCanvas(D, 'back'), bx = bc.getContext('2d'), fc = layerCanvas(D, 'front'), fx = fc.getContext('2d');
        var live = order.filter(function (i) { return imgs[i] && !(skip && pls[i].it.uid === skip); });
        function alphaOf(pl) { return anim && pl.it.uid === anim.uid ? anim.alpha : 1; }
        live.forEach(function (i) {
          var pl = pls[i], ji = jrImgs[pl.jr.key];
          if (ji) drawRing(bx, ji.all, px(pl.jr.top), pl.jr.deg, pl.jr.flip, k, alphaOf(pl));
        });
        live.forEach(function (i) {
          var pl = pls[i], ji = jrImgs[pl.jr.key];
          var a = anim && pl.it.uid === anim.uid ? anim : null;
          var dy = a ? a.dy * k : 0;
          fx.save();
          fx.globalAlpha = alphaOf(pl);
          var q = px(pl.q), layer = charmLayer(pl.info, imgs[i], photos[i], pl.it.name, k);
          fx.translate(q[0], q[1] + dy);
          fx.rotate(pl.rot);
          fx.drawImage(layer, -pl.info.anchor[0] * k, -pl.info.anchor[1] * k, pl.info.w_mm * k, pl.info.h_mm * k);
          fx.restore();
          if (ji) drawRing(fx, ji.near, px(pl.jr.top), pl.jr.deg, pl.jr.flip, k, alphaOf(pl));
          var w = pl.info.photo;
          if (w && w.shape === 'gem' && b.geo.bubble && !(a && a.alpha < 1)) {   // the gem's centre, for its bubble
            var ux = w.cx - pl.info.anchor[0], uy = w.cy - pl.info.anchor[1], cs = Math.cos(pl.rot), sn = Math.sin(pl.rot);
            gems.push({ x: pl.q[0] + ux * cs - uy * sn, y: pl.q[1] + ux * sn + uy * cs, r: w.r, photo: photos[i] });
          }
        });
        var uc = layerCanvas(D, 'both'), ux = uc.getContext('2d');
        ux.drawImage(bc, 0, 0); ux.drawImage(fc, 0, 0);
        ctx.save();                                  // the shadow alone: the layer itself is drawn off the canvas
        ctx.shadowColor = 'rgba(0,0,0,' + sh.opacity + ')';
        ctx.shadowOffsetX = sh.dx * k + 2 * D; ctx.shadowOffsetY = sh.dy * k; ctx.shadowBlur = sh.blur * k * 2;
        ctx.drawImage(uc, -2 * D, 0);
        ctx.restore();
        ctx.drawImage(bc, 0, 0);
        if (b.geo.hang === 'ring' && PV.jr.tube) {   // the loop wire again, over the rings' far halves
          ctx.save();
          ctx.beginPath();
          wireTube(b.geo.loop).forEach(function (p, j) { var v = px(p); if (j) ctx.lineTo(v[0], v[1]); else ctx.moveTo(v[0], v[1]); });
          ctx.closePath();
          ctx.clip();
          drawBase(ctx);
          ctx.restore();
        }
        ctx.drawImage(fc, 0, 0);
        gems.forEach(function (g) { drawBubble(ctx, D, k, px, g, b.geo.bubble, fc); });
      }
      var target = job.animateUid && pls.some(function (pl) { return pl.it.uid === job.animateUid; }) && !REDUCED ? job.animateUid : null;
      if (!target) { canvases.forEach(function (cv) { drawAll(cv.getContext('2d'), cv.width, null, null); }); return; }
      return new Promise(function (done) {
        var t0 = null, dur = 420;
        function step(ts) {
          if (seq !== SEQ[key]) return done();      // a newer render owns these canvases now
          if (t0 === null) t0 = ts;
          var t = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - t, 3);
          canvases.forEach(function (cv) { drawAll(cv.getContext('2d'), cv.width, null, t < 1 ? { uid: target, alpha: Math.min(1, t * 2), dy: -(1 - e) * 3 } : null); });
          if (t < 1) requestAnimationFrame(step); else done();
        }
        requestAnimationFrame(step);
      });
    }).catch(function (e) { console.warn('[MiniCharm] preview', e); });
  }

  /* ------------------------------------------------------------------------------------------ the page */
  var els = {
    rail: $('[data-fl-sets-rail]'), railNav: $('[data-fl-rail-nav]'),
    bases: $('[data-fl-bases]'), metals: $('[data-mc-metals-list]'), sizes: $('[data-fl-sizes]'), sizesList: $('[data-fl-sizes-list]'),
    rule: $('[data-mc-rule]'), cats: $('[data-fl-cats]'), grid: $('[data-fl-grid]'),
    chips: $('[data-fl-chips]'), orderLabel: $('[data-mc-order-label]'), orderHelp: $('[data-mc-order-help]'),
    reviewBase: $('[data-fl-review-base]'), atc: $('[data-fl-atc]'), error: $('[data-fl-error]'),
    stripBase: $('[data-fl-strip-base]'), stripCount: $('[data-fl-strip-count]'),
    review: $('[data-fl-canvas="review"]'), strip: $('[data-fl-canvas="strip"]'), zoom: $('[data-fl-canvas="zoom"]')
  };
  var dock = document.querySelector('[data-fl-dock]');
  var dockCanvas = dock ? dock.querySelector('[data-fl-canvas="dock"]') : null;
  var dockCaption = dock ? dock.querySelector('[data-fl-dock-caption]') : null;
  function mainCanvases() { return [els.review, els.strip, dockCanvas, dialogs.zoom && dialogs.zoom.open ? els.zoom : null]; }

  /* ---- Add to cart placement (owner 2026-10-14): on phones it sits under the base line, above the charm list */
  K.placeActions($('[data-fl-actions]'), els.orderLabel);

  function itemName(it, metal) {
    var v = itemVariant(it, metal);
    var n = v ? K.itemName(v) : it.product.short;
    return it.product.isPhoto && it.name ? n + ' “' + it.name + '”' : n;
  }
  function cartTitle(v, it) {
    return v.product.title + ' - ' + v.title + (it && it.name ? ' · Name: ' + it.name : '');
  }
  /** the charm itself, trimmed (the preview's sprite), so it fills a small thumbnail; a photo charm shows the photo */
  function thumbFor(it, metal) {
    if (it.photo) return it.photo.local || it.photo.thumb;
    var v = itemVariant(it, metal), c = charmInfo(v);
    return c && !c.photo ? c.img : ((v && v.img) || it.product.img);
  }
  function stoneThumb(v) { var c = PV.charms[v.sku]; return c && c.img ? c.img : (v.img || v.product.img); }
  function cardImg(p) {
    var v = variantsIn(p, state.metal)[0];
    return (v && v.img) || p.img;
  }

  /* ---- quick start set cards */
  function setItems(set, b, metal) {
    return set.items.map(function (si) {
      var v = SKU[si.sku];
      if (!v) return null;
      // a set keeps its own charms (owner 10/15: the Pet Portrait set shows the portrait, never the round photo
      // charm): a base that can't hold one of them doesn't fit the set, so setFits() leaves it out
      return { uid: uid(), product: v.product, value: v.product.multi ? variantValue(v) : null, photo: null, name: '', cfg: si, orig: v.product };
    });
  }
  function setFits(set, b) {
    var its = setItems(set, b, 'Gold');
    return its.every(Boolean) && b.counts.indexOf(its.length) > -1 && its.every(function (it) { return allowedOn(it.product, b); });
  }
  function setAvailable(set) { return setItems(set, null, 'Gold').every(function (it) { return it && (anyAvailable(it.product, 'Gold') || anyAvailable(it.product, 'Silver')); }); }
  function minPrice(b) { return Math.min.apply(null, b.product.variants.map(function (v) { return v.price; })); }
  function setPrice(set, b, metal, size) {
    var bv = size ? baseVariant(b, metal, size) : null;
    var base = bv ? bv.price : minPrice(b);
    return base + setItems(set, b, metal).reduce(function (s, it) { var v = itemVariant(it, metal); return s + (v ? v.price : 0); }, 0);
  }
  function featuredBase(set) {
    var b = set.featured && baseByKey(set.featured);
    return b && setFits(set, b) && inStock(b) ? b : null;
  }
  function setBases(set) {
    var fits = BASES.filter(function (b) { return setFits(set, b) && inStock(b); });
    var fb = featuredBase(set);
    return fb ? [fb].concat(fits.filter(function (b) { return b !== fb; })) : fits;
  }
  var SETS = (CFG.sets || []).filter(function (s) { return setAvailable(s) && setBases(s).length; });

  function renderSets() {
    if (!els.rail) return;
    var byo = $('[data-fl-byo-card]', els.rail);
    var html = SETS.map(function (s) {
      var bs = setBases(s), b0 = bs[0];
      var price = Math.min.apply(null, bs.map(function (b) { return setPrice(s, b, 'Gold'); }));
      var imgBase = bs.filter(function (b) { return s.img && s.img[b.key]; })[0];
      var img = imgBase ? s.img[imgBase.key] : b0.geo.img.gold;
      return '<li class="fl-set">' +
        '<button type="button" class="fl-set__btn" data-fl-set="' + esc(s.id) + '" aria-haspopup="dialog">' +
          '<span class="fl-set__media"><img src="' + esc(img) + '" alt="" width="400" height="400" loading="lazy" decoding="async"></span>' +
          '<span class="fl-set__name">' + esc(s.name) + '</span>' +
          '<span class="fl-set__price">From ' + money(price) + '</span>' +
          '<span class="fl-set__cta" aria-hidden="true">Select</span>' +
        '</button></li>';
    }).join('');
    if (byo) byo.insertAdjacentHTML('beforebegin', html); else els.rail.insertAdjacentHTML('beforeend', html);
    els.rail.scrollLeft = 0; // scroll anchoring would keep the BYO card in view, i.e. scrolled to the end
    $$('[data-fl-set]', els.rail).forEach(function (btn) {
      btn.addEventListener('click', function () { openSet(btn.getAttribute('data-fl-set'), btn); });
    });
    var byoLink = $('[data-fl-byo-link]');
    if (byoLink) byoLink.addEventListener('click', function (e) { e.preventDefault(); K.goTo('McStepBase'); });
    K.railNav(els.rail, els.railNav);
  }

  /* ---- step 1: piece, metal, ring size */
  /** a base's picture on its own (piece cards, the build-your-own card): the bracelet's is centred on its whole
   *  outline (owner 10/15); the others use the preview's base frame */
  function baseCardImg(b, metal) { return (b.geo.card || b.geo.img)[mkey(metal)]; }
  function renderBases() {
    els.bases.insertAdjacentHTML('beforeend', BASES.map(function (b) {
      var avail = inStock(b), id = 'McBase-' + b.key;
      return '<label class="fl-base' + (avail ? '' : ' is-soldout') + '" for="' + id + '">' +
        '<input class="fl-base__input" type="radio" name="mc-base" id="' + id + '" value="' + esc(b.key) + '"' + (avail ? '' : ' disabled') + '>' +
        '<span class="fl-base__card">' +
          '<span class="fl-base__media"><img src="' + esc(baseCardImg(b, 'Gold')) + '" alt="" width="300" height="300" loading="lazy" decoding="async" data-mc-base-img="' + b.key + '"></span>' +
          '<span class="fl-base__name">' + esc(b.label) + '</span>' +
          '<span class="fl-base__meta">' + (avail ? (isChain(b) ? '3, 5 or 7 charms' : '1 to 3 charms') : 'Sold out') + '</span>' +
          (CFG.showPrices ? '<span class="fl-base__price">' + money(minPrice(b)) + '</span>' : '') +
        '</span></label>';
    }).join(''));
    $$('.fl-base__input', els.bases).forEach(function (inp) {
      inp.addEventListener('change', function () { if (inp.checked) selectBase(inp.value, true); });
    });
  }
  function renderMetals() {
    var b = currentBase();
    els.metals.innerHTML = METALS.map(function (m) {
      var avail = !b || metalInStock(b, m), id = 'McMetal-' + m;
      return '<label class="mc-metal' + (avail ? '' : ' is-soldout') + '" for="' + id + '">' +
        '<input type="radio" name="mc-metal" id="' + id + '" value="' + m + '"' + (state.metal === m ? ' checked' : '') + (avail ? '' : ' disabled') + '>' +
        '<span><span class="mc-metal__dot mc-metal__dot--' + m.toLowerCase() + '" aria-hidden="true"></span>' + m +
        (avail ? '' : '<span class="visually-hidden"> sold out</span>') + '</span></label>';
    }).join('');
    $$('input', els.metals).forEach(function (inp) {
      inp.addEventListener('change', function () { if (inp.checked) selectMetal(inp.value, true); });
    });
  }
  function selectBase(key, user) {
    var b = baseByKey(key);
    if (!b) return;
    var changed = state.baseKey !== key;
    var before = state.items.map(function (it) { return it.product; });
    state.baseKey = key;
    if (changed) state.size = null;
    if (!metalInStock(b, state.metal)) state.metal = METALS.filter(function (m) { return metalInStock(b, m); })[0] || state.metal;
    var moved = [];
    state.items.forEach(function (it, i) {
      var q = convertFor(it.product, b);
      if (q !== it.product) { moved.push(it.product.short + ' became the ' + q.short + ' charm'); it.product = q; it.value = null; if (!q.photoCfg.name) it.name = ''; }
    });
    $$('.fl-base__input', els.bases).forEach(function (inp) { inp.checked = inp.value === key; });
    renderMetals();
    renderSizes();
    renderGrid();
    if (user) {
      var over = state.items.length - b.max;
      announce(b.label + ' selected. ' + countRule(b) + (moved.length ? ' Your ' + moved.join(', ') + ', your photo kept.' : '') +
        (over > 0 ? ' It holds ' + b.max + ', so remove ' + plural(over, 'charm', 'charms') + '.' : ''));
    }
    update({});
  }
  function selectMetal(m, user) {
    state.metal = m;
    renderGrid();
    if (user) {
      var gone = state.items.filter(function (it) { var v = itemVariant(it); return !v || !v.available; });
      announce(m + ' selected. Every charm is now ' + m.toLowerCase() + '.' + (gone.length ? ' ' + gone.map(function (it) { return itemName(it); }).join(', ') + ' is sold out in ' + m.toLowerCase() + '.' : ''));
    }
    update({});
  }
  function renderSizes() {
    var b = currentBase(), sz = sizesOf(b);
    if (!sz.length) { els.sizes.hidden = true; els.sizesList.innerHTML = ''; return; }
    els.sizes.hidden = false;
    els.sizesList.innerHTML = sz.map(function (s) {
      var v = baseVariant(b, state.metal, s), avail = v && v.available, id = 'McSize-' + s;
      return '<label class="fl-size' + (avail ? '' : ' is-soldout') + '" for="' + id + '">' +
        '<input type="radio" name="mc-size" id="' + id + '" value="' + esc(s) + '"' + (avail ? '' : ' disabled') + (state.size === s ? ' checked' : '') + '>' +
        '<span>' + esc(s) + (avail ? '' : '<span class="visually-hidden"> sold out</span>') + '</span></label>';
    }).join('');
    $$('input', els.sizesList).forEach(function (inp) {
      inp.addEventListener('change', function () { state.size = inp.value; announce('Size ' + inp.value + ' selected.'); update({}); });
    });
  }

  /* ---- step 2: charms */
  function catById(id) { return (CFG.categories || []).filter(function (c) { return c.id === id; })[0]; }
  function inCat(p, c) { return !c || c.id === 'all' || !c.match || c.match.some(function (m) { return p.handle.indexOf(m) > -1; }); }
  function visibleCharms() { var b = currentBase(); return CHARMS.filter(function (p) { return !b || allowedOn(p, b); }); }
  function renderCats() {
    var cats = (CFG.categories || [{ id: 'all', label: 'All' }]).filter(function (c) {
      return c.id === 'all' || CHARMS.some(function (p) { return inCat(p, c); });
    });
    els.cats.innerHTML = cats.map(function (c) {
      return '<button type="button" class="fl-chip-btn" data-fl-cat="' + esc(c.id) + '" aria-pressed="' + (c.id === state.cat) + '">' + esc(c.label) + '</button>';
    }).join('');
    $$('[data-fl-cat]', els.cats).forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.cat = btn.getAttribute('data-fl-cat');
        $$('[data-fl-cat]', els.cats).forEach(function (x) { x.setAttribute('aria-pressed', String(x === btn)); });
        filterGrid();
        announce(btn.textContent + ': ' + plural($$('.fl-charm:not([hidden])', els.grid).length, 'charm', 'charms') + '.');
      });
    });
    K.pillPeek(els.cats);                          // the pill cut by the right edge always peeks in 25-75%
  }
  function filterGrid() {
    var c = catById(state.cat);
    $$('.fl-charm', els.grid).forEach(function (li) { li.hidden = !inCat(CHARMS[Number(li.getAttribute('data-i'))], c); });
  }
  function renderGrid() {
    var b = currentBase();
    els.grid.innerHTML = CHARMS.map(function (p, i) {
      if (b && !allowedOn(p, b)) return '';
      var avail = anyAvailable(p, state.metal);
      var sub = p.isPhoto ? 'Your photo' : (p.multi ? K.rangeLabel(p, variantsIn(p, state.metal)) : '');
      var action = p.multi ? 'Choose' : 'Add';
      return '<li class="fl-charm' + (avail ? '' : ' is-soldout') + '" data-i="' + i + '">' +
        '<button type="button" class="fl-charm__btn" data-fl-charm="' + i + '"' + (p.multi || p.isPhoto ? ' aria-haspopup="dialog"' : '') + (avail ? '' : ' disabled') + '>' +
          '<span class="fl-charm__media"><img src="' + esc(cardImg(p) || '') + '" alt="" width="240" height="240" loading="lazy" decoding="async"></span>' +
          '<span class="fl-charm__name">' + esc(p.short) + '</span>' +
          (sub ? '<span class="fl-charm__sub">' + esc(sub) + '</span>' : '') +
          (avail ? '<span class="fl-charm__add" aria-hidden="true">' + action + '</span>' : '<span class="fl-charm__sub">Sold out</span>') +
          '<span class="visually-hidden" data-fl-charm-state></span>' +
        '</button>' +
        '<span class="fl-charm__count" data-fl-count aria-hidden="true" hidden></span>' +
        (p.multi || p.isPhoto ? '' :
          '<button type="button" class="fl-charm__minus" data-fl-minus="' + i + '" hidden>' +
            '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="14" height="14"><path d="M5 12h14" stroke="currentColor" stroke-width="2.4"/></svg>' +
            '<span class="visually-hidden">Remove one ' + esc(p.short) + '</span></button>') +
      '</li>';
    }).join('');
    $$('[data-fl-charm]', els.grid).forEach(function (btn) {
      btn.addEventListener('click', function () { onCharm(CHARMS[Number(btn.getAttribute('data-fl-charm'))], btn); });
    });
    $$('[data-fl-minus]', els.grid).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var p = CHARMS[Number(btn.getAttribute('data-fl-minus'))];
        for (var i = state.items.length - 1; i >= 0; i--) if (state.items[i].product === p) { removeItem(state.items[i].uid, btn); break; }
      });
    });
    filterGrid();
    updateGridState();
  }
  function full() { var b = currentBase(); return !!b && state.items.length >= b.max; }
  function fullText() { var b = currentBase(); return 'Your ' + b.noun + ' holds ' + b.max + ' charms. Remove one to add another.'; }
  function onCharm(p, btn) {
    clearError();
    if (!state.baseKey) selectBase(BASES.filter(function (x) { return inStock(x); })[0].key, false);
    if (p.isPhoto) {
      if (full()) { announce(fullText()); return; }
      openPhotoFor(p, null, '', btn, function (photo, name) { addItem(p, null, photo, name); });
      return;
    }
    if (p.multi) { openPicker(p, btn); return; }
    addItem(p, null);
  }
  function addItem(p, value, photo, name) {
    var b = currentBase();
    if (full()) { announce(fullText()); return null; }
    var it = newItem(p, value, photo, name);
    state.items.push(it);
    var n = state.items.length, need = countNeed(b, n);
    announce('Added ' + itemName(it) + ' in spot ' + (state.items.indexOf(it) + 1) + '. ' + plural(n, 'charm', 'charms') + (need ? '; ' + need.toLowerCase() : ', ready to add to cart') + '.');
    update({ animateUid: it.uid });
    return it;
  }
  function removeItem(id, focusFrom) {
    var idx = -1;
    state.items.forEach(function (it, i) { if (it.uid === id) idx = i; });
    if (idx < 0) return;
    var it = state.items.splice(idx, 1)[0];
    var need = countNeed(currentBase(), state.items.length);
    announce('Removed ' + itemName(it) + '. ' + plural(state.items.length, 'charm', 'charms') + (need ? '; ' + need.toLowerCase() : '') + '.');
    update({});
    if (!focusFrom) return;
    if (focusFrom.hasAttribute('data-fl-minus') && focusFrom.hidden) {
      var card = focusFrom.closest('.fl-charm'), main = card && card.querySelector('[data-fl-charm]');
      if (main) main.focus();
    } else if (!document.body.contains(focusFrom)) {
      var next = $$('[data-fl-remove]', root)[Math.min(idx, state.items.length - 1)];
      (next || document.getElementById('McStepCharms')).focus();
    }
  }
  /** Move a charm one spot left (-1) or right (+1). */
  function moveItem(id, dir) {
    var i = -1;
    state.items.forEach(function (it, k) { if (it.uid === id) i = k; });
    if (i < 0) return;
    var j = i + dir;
    if (j < 0 || j >= state.items.length) return;
    var it = state.items.splice(i, 1)[0];
    state.items.splice(j, 0, it);
    var at = state.items.indexOf(it);
    announce(itemName(it) + ' moved to spot ' + (at + 1) + ' of ' + state.items.length + '.');
    update({});
    var again = $('[data-mc-move="' + id + '"][data-mc-dir="' + dir + '"]', root);
    if (!again || again.getAttribute('aria-disabled') === 'true') again = $('[data-mc-move="' + id + '"][data-mc-dir="' + (-dir) + '"]', root) || $('[data-fl-remove="' + id + '"]', root);
    if (again) again.focus();
  }
  function updateGridState() {
    var isFull = full();
    $$('.fl-charm', els.grid).forEach(function (li) {
      var p = CHARMS[Number(li.getAttribute('data-i'))];
      var c = state.items.filter(function (it) { return it.product === p; }).length;
      var badge = $('[data-fl-count]', li), minus = $('[data-fl-minus]', li), st = $('[data-fl-charm-state]', li);
      badge.hidden = !c; badge.textContent = c ? '×' + c : '';
      if (minus) minus.hidden = !c;
      li.classList.toggle('is-in', !!c);
      if (st) st.textContent = (c ? ', ' + c + ' added' : '') + (isFull ? ', your piece is full' : '');
    });
  }

  /* ---- review + strip + dock */
  function chipHtml(it, i, n, b) {
    var name = itemName(it), v = itemVariant(it);
    var over = i >= b.max;
    var gone = !v || !v.available;
    var leftOk = i > 0, rightOk = i < n - 1;
    function mv(dir, ok, label, path) {
      return '<button type="button" class="fl-iconbtn mc-move" data-mc-move="' + it.uid + '" data-mc-dir="' + dir + '" aria-disabled="' + !ok + '">' +
        '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="14" height="14"><path d="' + path + '" fill="none" stroke="currentColor" stroke-width="2.2"/></svg>' +
        '<span class="visually-hidden">' + label + ' ' + esc(name) + '</span></button>';
    }
    return '<li class="fl-chip mc-chip' + (over ? ' is-over' : '') + '">' +
      '<span class="mc-chip__pos" aria-hidden="true">' + (i + 1) + '</span>' +
      '<span class="fl-chip__media' + (it.photo ? ' fl-chip__media--photo' : '') + '"><img src="' + esc(thumbFor(it) || '') + '" alt="" width="40" height="40" loading="lazy"></span>' +
      '<span class="fl-chip__name">' + esc(name) +
        (gone ? '<span class="mc-chip__tag mc-chip__tag--warn">Sold out in ' + esc(state.metal.toLowerCase()) + '</span>' : '') +
        (over ? '<span class="mc-chip__tag mc-chip__tag--warn">Won’t fit on the ' + esc(b.noun) + '</span>' : '') +
        (it.product.isPhoto && !it.photo ? '<span class="mc-chip__tag mc-chip__tag--warn">Add your photo</span>' : '') + '</span>' +
      (it.product.isPhoto ? '<button type="button" class="fl-linkbtn fl-chip__edit" data-fl-photo-edit="' + it.uid + '">' + (it.photo ? 'Change photo' : 'Add photo') + '<span class="visually-hidden"> for ' + esc(name) + '</span></button>' : '') +
      (n < 2 ? '' : mv(-1, leftOk, 'Move left:', 'M15 5l-7 7 7 7') + mv(1, rightOk, 'Move right:', 'M9 5l7 7-7 7')) +
      '<button type="button" class="fl-iconbtn fl-chip__x" data-fl-remove="' + it.uid + '">' +
        '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="14" height="14"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2"/></svg>' +
        '<span class="visually-hidden">Remove ' + esc(name) + '</span></button>' +
    '</li>';
  }
  function renderChips() {
    var b = currentBase();
    var ae = document.activeElement, keep = null;
    if (ae && els.chips.contains(ae)) {
      ['data-fl-remove', 'data-fl-photo-edit'].forEach(function (k) { if (!keep && ae.hasAttribute(k)) keep = '[' + k + '="' + ae.getAttribute(k) + '"]'; });
      if (!keep && ae.hasAttribute('data-mc-move')) keep = '[data-mc-move="' + ae.getAttribute('data-mc-move') + '"][data-mc-dir="' + ae.getAttribute('data-mc-dir') + '"]';
    }
    var n = state.items.length;
    els.chips.innerHTML = b ? state.items.map(function (it, i) { return chipHtml(it, i, n, b); }).join('') : '';
    els.orderLabel.hidden = !n;
    els.orderHelp.textContent = n > 1 ? (isChain(b) ? 'Left to right as worn: spot 1 is nearest the clasp. Use the arrows to change the order.' : 'Left to right on the ring’s loop. Use the arrows to change the order.') : '';
    $$('[data-fl-remove]', els.chips).forEach(function (btn) { btn.addEventListener('click', function () { removeItem(btn.getAttribute('data-fl-remove'), btn); }); });
    $$('[data-mc-move]', els.chips).forEach(function (btn) {
      btn.addEventListener('click', function () { if (btn.getAttribute('aria-disabled') !== 'true') moveItem(btn.getAttribute('data-mc-move'), Number(btn.getAttribute('data-mc-dir'))); });
    });
    $$('[data-fl-photo-edit]', els.chips).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-fl-photo-edit'), it = state.items.filter(function (x) { return x.uid === id; })[0];
        if (!it) return;
        openPhotoFor(it.product, it.photo, it.name, btn, function (photo, name) {
          it.photo = photo; it.name = name || '';
          announce('Photo updated.');
          update({});
          var again = $('[data-fl-photo-edit="' + id + '"]', root);
          if (again) again.focus();
        });
      });
    });
    if (keep) { var k = $(keep, root); if (k) k.focus(); }
  }
  function previewLabel(b, items, metal) {
    if (!b) return 'Choose a bracelet, necklace or ring to see your preview';
    var drawn = items.slice(0, b.max);
    if (!drawn.length) return 'Preview: an empty ' + metal.toLowerCase() + ' ' + b.noun;
    return 'Preview: ' + metal.toLowerCase() + ' ' + b.noun + ' with, left to right, ' + drawn.map(function (it) { return itemName(it, metal); }).join(', ');
  }
  function summaryText(b, n) {
    var need = countNeed(b, n);
    return n ? plural(n, 'charm', 'charms') + (need ? ' · ' + need.toLowerCase() : '') : 'No charms yet';
  }

  function update(opts) {
    opts = opts || {};
    var b = currentBase(), n = state.items.length;
    updateGridState();
    renderChips();
    if (els.rule) els.rule.textContent = countRule(b);
    var bv = b ? baseVariant(b, state.metal, state.size) : null;
    els.reviewBase.innerHTML = b
      ? '<strong>' + esc(state.metal) + ' ' + esc(b.label) + '</strong>' + (b.sizeIdx > -1 && state.size ? ' &middot; Size ' + esc(state.size) : '') +
        (b.blurb ? '<br><span class="fl-help">' + esc(b.blurb) + '</span>' : '')
      : 'Choose your piece in step 1.';
    if (CFG.showPrices) {
      var total = (bv ? bv.price : 0) + state.items.reduce(function (s, it) { var v = itemVariant(it); return s + (v ? v.price : 0); }, 0);
      $('[data-fl-total-note]').textContent = 'Total ' + money(total);
    }
    els.stripBase.textContent = b ? state.metal + ' ' + b.label : 'Choose your piece';
    els.stripCount.textContent = b ? summaryText(b, n) : 'No charms yet';
    if (dockCaption) dockCaption.textContent = b ? state.metal + ' ' + b.label + ' · ' + (n ? summaryText(b, n) : 'add charms in step 2') : 'Choose your piece to start';
    $$('[data-mc-base-img]', root).forEach(function (im) { var bb = baseByKey(im.getAttribute('data-mc-base-img')); if (bb) im.src = baseCardImg(bb, state.metal); });
    var byoImg = $('[data-fl-byo-card] img');
    if (byoImg && b) byoImg.src = baseCardImg(b, state.metal);
    var label = previewLabel(b, state.items, state.metal);
    [els.review, els.zoom, dockCanvas].forEach(function (cv) { if (cv) cv.setAttribute('aria-label', label); });
    if (b) {
      mainCanvases().forEach(fitCanvas);
      render(mainCanvases(), { base: b, metal: state.metal, items: state.items, key: 'main', animateUid: opts.animateUid });
    }
    clearError();
    updateAtc();
    save();
  }

  /* ---- errors */
  function showError(msg) { if (els.error) els.error.textContent = msg; }
  function clearError() { if (els.error) els.error.textContent = ''; }

  /* ---------------------------------------------------------------------------------------------- dialogs */
  var PICK = K.picker(dialogs.picker, UI);
  function openPicker(p, opener) {
    PICK.open(p, opener, {
      variants: variantsIn(p, state.metal),
      thumb: stoneThumb,
      help: function () {
        var b = currentBase(), n = state.items.length;
        return full() ? fullText() : 'Tap to add. ' + n + ' of ' + b.max + ' charms' + (countNeed(b, n) ? ' (' + countNeed(b, n).toLowerCase() + ')' : '') + '.';
      },
      count: function (v) { return state.items.filter(function (it) { return it.product === p && itemVariant(it) === v; }).length; },
      add: function (v) { addItem(p, p.multi ? variantValue(v) : null); },
      removeOne: function (v) {
        for (var i = state.items.length - 1; i >= 0; i--) if (state.items[i].product === p && itemVariant(state.items[i]) === v) { removeItem(state.items[i].uid); break; }
      }
    });
  }
  var PHOTO = K.photoDialog(dialogs.photo, UI, { cloudinary: CFG.cloudinary, log: '[MiniCharm]' });
  function openPhotoFor(p, current, name, opener, done) {
    var c = p.photoCfg || {};
    PHOTO.open({
      title: 'Add your photo — ' + p.short,
      aspect: c.aspect || 1, shape: c.shape || 'circle', current: current || null,
      name: c.name ? { label: c.name.label, max: c.name.max, help: c.name.help, value: name || '' } : null,
      onDone: done
    }, opener);
  }

  /* ---- zoom (phones: tap the strip's mini preview) */
  var zoomBtn = $('[data-fl-strip-zoom]');
  if (zoomBtn) zoomBtn.addEventListener('click', function () {
    if (!currentBase()) { K.goTo('McStepBase'); return; }
    openDialog(dialogs.zoom, zoomBtn);
    setTimeout(function () { fitCanvas(els.zoom); render([els.zoom], { base: currentBase(), metal: state.metal, items: state.items, key: 'main' }); }, 0);
  });

  /* ---- quick-start set dialog */
  var setState = null;
  function openSet(id, opener) {
    var set = SETS.filter(function (s) { return s.id === id; })[0];
    if (!set) return;
    var b = setBases(set)[0];
    var metal = metalInStock(b, 'Gold') ? 'Gold' : 'Silver';
    setState = { set: set, baseKey: b.key, metal: metal, size: null, items: setItems(set, b, metal) };
    $('[data-fl-set-title]', dialogs.set).textContent = set.name;
    renderSetBody();
    $('[data-fl-set-error]', dialogs.set).textContent = '';
    openDialog(dialogs.set, opener);
    K.track('mini_charm_set_view', { set_id: set.id });
  }
  function renderSetBody() {
    var d = dialogs.set, s = setState, set = s.set, b = baseByKey(s.baseKey);
    var body = $('[data-fl-set-body]', d);
    // only the pieces this set fits (owner 10/15: no greyed "Won't fit" card); a sold-out piece still shows, greyed
    var shown = BASES.filter(function (bb) { return setFits(set, bb); });
    var basesHtml = shown.map(function (bb) {
      var avail = inStock(bb), id = 'McSetBase-' + bb.key;
      var why = !avail ? 'Sold out' : (isChain(bb) ? plural(set.items.length, 'charm', 'charms') : 'On the loop');
      return '<label class="fl-base fl-base--sm' + (avail ? '' : ' is-soldout') + '" for="' + id + '">' +
        '<input class="fl-base__input" type="radio" name="mc-set-base" id="' + id + '" value="' + bb.key + '"' + (s.baseKey === bb.key ? ' checked' : '') + (avail ? '' : ' disabled') + '>' +
        '<span class="fl-base__card"><span class="fl-base__media"><img src="' + esc(baseCardImg(bb, s.metal)) + '" alt="" width="160" height="160" loading="lazy"></span>' +
        '<span class="fl-base__text"><span class="fl-base__name">' + esc(bb.label) + '</span><span class="fl-base__meta">' + esc(why) + '</span></span></span></label>';
    }).join('');
    var metals = '<fieldset class="mc-metals mc-metals--sm"><legend class="fl-label">Metal</legend><div class="mc-metals__list">' + METALS.map(function (m) {
      var avail = metalInStock(b, m), id = 'McSetMetal-' + m;
      return '<label class="mc-metal' + (avail ? '' : ' is-soldout') + '" for="' + id + '"><input type="radio" name="mc-set-metal" id="' + id + '" value="' + m + '"' + (s.metal === m ? ' checked' : '') + (avail ? '' : ' disabled') + '>' +
        '<span><span class="mc-metal__dot mc-metal__dot--' + m.toLowerCase() + '" aria-hidden="true"></span>' + m + '</span></label>';
    }).join('') + '</div></fieldset>';
    var sizes = '';
    if (sizesOf(b).length) {
      sizes = '<fieldset class="fl-sizes"><legend class="fl-label">Ring size</legend><div class="fl-sizes__list">' + sizesOf(b).map(function (z) {
        var v = baseVariant(b, s.metal, z), avail = v && v.available, vid = 'McSetSize-' + z;
        return '<label class="fl-size' + (avail ? '' : ' is-soldout') + '" for="' + vid + '"><input type="radio" name="mc-set-size" id="' + vid + '" value="' + esc(z) + '"' + (s.size === z ? ' checked' : '') + (avail ? '' : ' disabled') + '><span>' + esc(z) + '</span></label>';
      }).join('') + '</div></fieldset>';
    }
    var dense = s.items.filter(function (it) { return it.product.isPhoto || (it.cfg && it.cfg.pick && it.product.multi); }).length >= 3;
    var picks = s.items.map(function (it, i) {
      var p = it.product;
      if (p.isPhoto) {
        return '<div class="fl-field fl-field--photo"><span class="fl-label" id="McSetPhotoLabel' + i + '">' + esc(p.short) + (it.name ? ' · “' + esc(it.name) + '”' : '') + '</span>' +
          K.uploadButton({ hook: 'data-mc-set-photo="' + i + '"', labelId: 'McSetPhotoLabel' + i, photo: it.photo ? (it.photo.local || it.photo.thumb) : null,
                           rect: !!(p.photoCfg && p.photoCfg.shape === 'rect') }) + '</div>';
      }
      if (!it.cfg || !it.cfg.pick || !p.multi) return '';
      var sid = 'McSetPick-' + i, v = itemVariant(it, s.metal), label = it.cfg.label || CFG.pickLabels[p.pickOption] || p.pickOption;
      if (isStone(p)) {
        return '<div class="fl-field"><span class="fl-label" id="' + sid + '-l">' + esc(label) + '</span>' +
          '<button type="button" class="fl-select fl-select--stone" data-mc-set-stone="' + i + '" aria-haspopup="dialog" aria-labelledby="' + sid + '-l ' + sid + '-v">' +
            '<img class="fl-select__thumb" src="' + esc(v ? stoneThumb(v) : '') + '" alt="" width="28" height="28">' +
            '<span class="fl-select__text" id="' + sid + '-v">' + esc(v ? (dense ? MONTHS[BS_MONTH[variantValue(v)]] || variantLabel(v) : variantLabel(v)) : '') + '</span></button></div>';
      }
      return '<div class="fl-field"><label class="fl-label" for="' + sid + '">' + esc(label) + '</label>' +
        '<select class="fl-select" id="' + sid + '" data-mc-set-pick="' + i + '">' +
        variantsIn(p, s.metal).map(function (x) {
          return '<option value="' + esc(variantValue(x)) + '"' + (variantValue(x) === it.value ? ' selected' : '') + (x.available ? '' : ' disabled') + '>' + esc(variantLabel(x)) + (x.available ? '' : ' (sold out)') + '</option>';
        }).join('') + '</select></div>';
    }).join('');
    var inside = s.items.map(function (it) {
      return '<li><img src="' + esc(thumbFor(it, s.metal) || '') + '" alt="" width="32" height="32" loading="lazy"' + (it.photo ? ' class="is-photo"' : '') + '>' + esc(itemName(it, s.metal)) + '</li>';
    }).join('');
    body.innerHTML =
      '<div class="fl-setdlg mc-setdlg' + (dense ? ' fl-setdlg--dense' : '') + '">' +
        '<div class="fl-setdlg__preview"><canvas class="fl-canvas" data-fl-canvas="set" width="340" height="340" role="img" aria-label="' + esc(previewLabel(b, s.items, s.metal)) + '"></canvas>' +
          '<p class="fl-setdlg__tag">' + esc(set.tagline || '') + '</p></div>' +
        '<div class="fl-setdlg__form">' +
          '<fieldset class="fl-bases fl-bases--sm mc-bases--n' + shown.length + '"><legend class="fl-label">Piece</legend>' + basesHtml + '</fieldset>' +
          '<div class="mc-setdlg__opts">' + metals + sizes + '</div>' +
          (picks ? '<div class="fl-setdlg__picks">' + picks + '</div>' : '') +
          '<div class="fl-field fl-field--inside"><span class="fl-label">Left to right</span><ol class="fl-inside">' + inside + '</ol></div>' +
        '</div>' +
      '</div>';
    $$('input[name="mc-set-base"]', body).forEach(function (inp) {
      inp.addEventListener('change', function () {
        var nb = baseByKey(inp.value);
        s.baseKey = inp.value; s.size = null;
        if (!metalInStock(nb, s.metal)) s.metal = METALS.filter(function (m) { return metalInStock(nb, m); })[0] || s.metal;
        renderSetBody();                         // only pieces that hold every charm of the set are offered
        var again = $('#McSetBase-' + inp.value, body);
        if (again) again.focus();
      });
    });
    $$('input[name="mc-set-metal"]', body).forEach(function (inp) {
      inp.addEventListener('change', function () { s.metal = inp.value; renderSetBody(); var again = $('#McSetMetal-' + inp.value, body); if (again) again.focus(); });
    });
    $$('input[name="mc-set-size"]', body).forEach(function (inp) {
      inp.addEventListener('change', function () { s.size = inp.value; updateSetFoot(); });
    });
    $$('[data-mc-set-pick]', body).forEach(function (sel) {
      sel.addEventListener('change', function () {
        s.items[Number(sel.getAttribute('data-mc-set-pick'))].value = sel.value;
        drawSetPreview(); refreshInside(); updateSetFoot();
      });
    });
    if ($('[data-mc-set-stone]', body)) {
      CHARMS.forEach(function (cp) { if (isStone(cp)) variantsIn(cp, s.metal).forEach(function (v) { loadImg(stoneThumb(v)).catch(function () {}); }); });
    }
    $$('[data-mc-set-stone]', body).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = Number(btn.getAttribute('data-mc-set-stone')), it = s.items[i];
        PICK.openOne(it.product, btn, {
          variants: variantsIn(it.product, s.metal), current: itemVariant(it, s.metal), thumb: stoneThumb,
          onPick: function (v) {
            it.value = variantValue(v);
            renderSetBody();
            var f = $('[data-mc-set-stone="' + i + '"]', dialogs.set);
            if (f) f.focus();
            announce((it.cfg.label || 'Birth month') + ': ' + variantLabel(v) + '.');
          }
        });
      });
    });
    $$('[data-mc-set-photo]', body).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = Number(btn.getAttribute('data-mc-set-photo')), it = s.items[i];
        // the photo dialog stacks on top of the set dialog (both modal); on close focus returns to this button
        openPhotoFor(it.product, it.photo, it.name, btn, function (photo, name) {
          it.photo = photo; it.name = name || '';
          renderSetBody();
          var again = $('[data-mc-set-photo="' + i + '"]', body);
          if (again) again.focus();
          announce('Photo added to your ' + set.name + ' set.');
        });
      });
    });
    updateSetFoot();
    setTimeout(drawSetPreview, 0);   // after layout (a hidden tab never runs rAF, which left the preview blank)
  }
  function refreshInside() {
    var ul = $('.fl-inside', dialogs.set);
    if (!ul) return;
    ul.innerHTML = setState.items.map(function (it) {
      return '<li><img src="' + esc(thumbFor(it, setState.metal) || '') + '" alt="" width="32" height="32" loading="lazy"' + (it.photo ? ' class="is-photo"' : '') + '>' + esc(itemName(it, setState.metal)) + '</li>';
    }).join('');
  }
  function drawSetPreview() {
    var cv = $('[data-fl-canvas="set"]', dialogs.set);
    if (!cv || !setState) return;
    var b = baseByKey(setState.baseKey);
    fitCanvas(cv);
    cv.setAttribute('aria-label', previewLabel(b, setState.items, setState.metal));
    render([cv], { base: b, metal: setState.metal, items: setState.items, key: 'set', fit: 'card' });
  }
  function setMissing() {
    var s = setState, b = baseByKey(s.baseKey);
    if (sizesOf(b).length && !s.size) return 'Choose a ring size';
    if (s.items.some(function (it) { return it.product.isPhoto && !it.photo; })) return 'Upload your photo to continue';
    if (s.items.some(function (it) { var v = itemVariant(it, s.metal); return !v || !v.available; })) return 'One of these charms is sold out in ' + s.metal.toLowerCase();
    var bv = baseVariant(b, s.metal, s.size);
    if (!bv || !bv.available) return 'This ' + b.noun + ' is sold out in ' + s.metal.toLowerCase();
    return '';
  }
  function updateSetFoot() {
    var d = dialogs.set, s = setState, b = baseByKey(s.baseKey);
    var btn = $('[data-fl-set-atc]', d);
    var price = setPrice(s.set, b, s.metal, s.size);
    var miss = setMissing();
    btn.textContent = (miss || 'Add set to cart') + ' — ' + money(price);
    btn.setAttribute('aria-disabled', miss ? 'true' : 'false');
    btn.classList.toggle('is-disabled', !!miss);
  }
  (function wireSet() {
    var d = dialogs.set;
    if (!d) return;
    $('[data-fl-set-atc]', d).addEventListener('click', function () {
      var s = setState, err = $('[data-fl-set-error]', d), miss = setMissing();
      if (miss) {
        err.textContent = miss + '.';
        var target = miss.indexOf('photo') > -1 ? $('[data-mc-set-photo]', d) : $('input[name="mc-set-size"]:not(:disabled)', d);
        if (target) target.focus();
        return;
      }
      err.textContent = '';
      var b = baseByKey(s.baseKey);
      addToCart(b, baseVariant(b, s.metal, s.size), s.items, s.metal, s.set.id, this).then(function (r) {
        if (r.ok) closeDialog(d); else if (!r.busy) err.textContent = r.msg || 'Something went wrong adding your set. Please try again.';
      });
    });
    $('[data-fl-set-customize]', d).addEventListener('click', function () {
      var s = setState;
      state.baseKey = s.baseKey; state.metal = s.metal; state.size = s.size;
      state.items = s.items.map(function (it) { return newItem(it.product, it.value, it.photo, it.name); });
      $$('.fl-base__input', els.bases).forEach(function (inp) { inp.checked = inp.value === state.baseKey; });
      renderMetals(); renderSizes(); renderGrid();
      d.__onClose = function () {
        update({});
        K.goTo('McStepCharms');
        announce(s.set.name + ' set loaded. Add, remove or reorder charms below.');
      };
      closeDialog(d);
    });
  })();

  /* ---------------------------------------------------------------------------------------------- cart */
  /** Resolves {ok, msg}. Base line + one line per charm, in position order (the kit sends one request at a time). */
  function addToCart(b, bv, items, metal, setId, btn) {
    if (!bv) return Promise.resolve({ ok: false, msg: '' });
    var bundleId = 'mini_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);
    var lines0 = items.map(function (it) { return { it: it, v: itemVariant(it, metal) }; });
    var parent = {
      _charm_bundle_id: bundleId,
      _charm_bundle_parent: 'true',
      _charm_bundle_charm_count: String(lines0.length),
      _mini_charm: 'true',
      _mini_charm_set: setId || 'custom'
    };
    // visible: Charm 1..N in POSITION order (spot 1 nearest the clasp / leftmost on the ring's loop), for the packer
    lines0.forEach(function (o, i) { parent['Charm ' + (i + 1)] = cartTitle(o.v, o.it); });
    var lines = [{ id: bv.id, quantity: 1, properties: parent }];
    lines0.forEach(function (o, i) {
      var props = {
        _charm_bundle_id: bundleId,
        _charm_bundle_child: 'true',
        _slot_position: String(i + 1),
        _charm_title: o.v.product.title
      };
      if (o.it.photo) {
        props.photo = o.it.photo.url;
        if (o.it.product.photoCfg && o.it.product.photoCfg.circle) props._circlerender = 'CIRCLE';
      }
      if (o.it.name) props.Name = o.it.name;
      lines.push({ id: o.v.id, quantity: 1, properties: props });
    });
    return K.addLines(lines, {
      btn: btn, log: '[MiniCharm]',
      soldOut: 'Sorry, part of your design just sold out. Please refresh and try again.',
      failed: 'Something went wrong adding your design. Please try again.',
      onRestore: function () { if (btn === els.atc) updateAtc(); else if (setState) updateSetFoot(); },
      onAdded: function () {
        announce('Added to your cart.');
        K.track('mini_charm_add', { set_id: setId || 'custom', base_sku: bv.sku, charms: lines0.length });
        try {
          if (window._learnq) {
            var host = window.item || {};
            window._learnq.push(['track', 'Added to Cart', {
              Name: bv.product.title + (setId && setId !== 'custom' ? ' (' + setId + ' set)' : ' (mini charms)'),
              ProductID: bv.product.id, VariantID: bv.id, SKU: bv.sku,
              Price: (bv.price + lines0.reduce(function (s, o) { return s + o.v.price; }, 0)) / 100,
              Charms: lines0.map(function (o) { return cartTitle(o.v, o.it); }),
              URL: host.URL || window.location.href, ImageURL: host.ImageURL || '', Brand: host.Brand || 'Wear Felicity'
            }]);
          }
        } catch (e) { /* ok */ }
      }
    });
  }

  function atcBlocker() {
    var b = currentBase(), n = state.items.length;
    if (!b) return { msg: 'Choose your piece in step 1', go: 'McStepBase' };
    if (!inStock(b, state.metal)) return { msg: 'The ' + state.metal.toLowerCase() + ' ' + b.noun + ' is sold out. Choose another', go: 'McStepBase' };
    if (sizesOf(b).length && !state.size) return { msg: 'Choose a ring size', go: 'McStepBase' };
    var bv = baseVariant(b, state.metal, state.size);
    if (!bv || !bv.available) return { msg: 'That size is sold out. Choose another', go: 'McStepBase' };
    var need = countNeed(b, n);
    if (need) return { msg: need, go: n > b.max ? 'McStepReview' : 'McStepCharms' };
    var noPhoto = state.items.filter(function (it) { return it.product.isPhoto && !it.photo; })[0];
    if (noPhoto) return { msg: 'Add a photo to your ' + noPhoto.product.short + ' charm', go: 'McStepReview' };
    var gone = state.items.filter(function (it) { var v = itemVariant(it); return !v || !v.available; })[0];
    if (gone) return { msg: itemName(gone) + ' is sold out in ' + state.metal.toLowerCase() + '. Remove it to continue', go: 'McStepReview' };
    return null;
  }
  function updateAtc() {
    var bl = atcBlocker();
    els.atc.setAttribute('aria-disabled', bl ? 'true' : 'false');
    els.atc.classList.toggle('is-disabled', !!bl);
    els.atc.textContent = bl ? bl.msg : 'Add to cart';
  }
  els.atc.addEventListener('click', function () {
    var bl = atcBlocker();
    if (bl) { showError(bl.msg + '.'); K.goTo(bl.go); return; }
    clearError();
    var b = currentBase();
    addToCart(b, baseVariant(b, state.metal, state.size), state.items, state.metal, 'custom', els.atc).then(function (r) {
      if (!r.ok && !r.busy) showError(r.msg || 'Something went wrong adding your design. Please try again.');
    });
  });

  /* ---------------------------------------------------------------------------------------- navigation */
  [$('[data-fl-review-link]'), document.querySelector('[data-fl-dock-review]')].forEach(function (a) {
    if (a) a.addEventListener('click', function (e) { e.preventDefault(); K.goTo('McStepReview'); });
  });
  var syncOffset = K.stickyOffset();
  var lastW = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastW) return;   // phones fire resize when the URL bar slides; only a real width change re-renders
    lastW = window.innerWidth;
    update({});
  });
  // pinch zoom: redraw the previews at the new magnification once the gesture settles (fitCanvas reads the scale)
  var lastScale = window.visualViewport ? window.visualViewport.scale : 1, zoomTimer = null;
  if (window.visualViewport) window.visualViewport.addEventListener('resize', function () {
    clearTimeout(zoomTimer);
    zoomTimer = setTimeout(function () {
      var sc = window.visualViewport.scale;
      if (Math.abs(sc - lastScale) < 0.15) return;
      lastScale = sc;
      update({});
      if (dialogs.set && dialogs.set.open) drawSetPreview();
    }, 200);
  });

  /* -------------------------------------------------------------------------------------------- init */
  function param(name) { var m = new RegExp('[?&]' + name + '=([^&#]+)', 'i').exec(window.location.search); return m ? decodeURIComponent(m[1]) : null; }
  function init() {
    document.documentElement.classList.add('fl-page');
    if (dock) { dock.hidden = false; root.classList.add('fl--docked'); document.documentElement.classList.add('fl-has-dock'); }
    renderSets();
    renderBases();
    renderCats();
    var restored = restore();
    // ?base= (from a base's product page) and ?metal= win over a restored design's base
    var qb = param('base'), qm = param('metal');
    if (qb && baseByKey(qb) && inStock(baseByKey(qb))) state.baseKey = qb;
    if (qm) { qm = qm.charAt(0).toUpperCase() + qm.slice(1).toLowerCase(); if (METALS.indexOf(qm) > -1) state.metal = qm; }
    if (!state.baseKey) state.baseKey = BASES.filter(function (b) { return inStock(b); })[0].key;
    var b = currentBase();
    state.items.forEach(function (it) { it.product = convertFor(it.product, b); });
    $$('.fl-base__input', els.bases).forEach(function (inp) { inp.checked = inp.value === state.baseKey; });
    renderMetals();
    renderSizes();
    renderGrid();
    syncOffset();
    update({});
    // ?set=<id> opens that set (ads can link straight to a set); ?charm=<handle> (a charm's product page) starts it
    var ms = param('set'), mc = param('charm');
    if (ms && SETS.some(function (s) { return s.id === ms; })) {
      openSet(ms, $('[data-fl-set="' + ms + '"]'));
    } else if (mc && byHandle(mc)) {
      var p = byHandle(mc), card = $('[data-fl-charm="' + CHARMS.indexOf(p) + '"]');
      if (allowedOn(p, currentBase()) && card) { K.goTo('McStepCharms'); setTimeout(function () { onCharm(p, card); }, REDUCED ? 0 : 500); }
    }
    if (restored && state.items.length) announce('Your design was restored: ' + plural(state.items.length, 'charm', 'charms') + '.');
    // warm the other bases' images when idle
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1500); };
    idle(function () { BASES.forEach(function (bb) { METALS.forEach(function (m) { baseImages(bb, m).catch(function () {}); }); }); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
